import React, { memo } from 'react'
import { Grid } from '@mui/material'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import CommonContent from '../../../../components/Content'
import { useContent } from './Content.hooks'

const Content = props => {
	const [
		{
			classes,
			cx,
			mobileAlignment,
			contentClasses,
			image,
			text,
			textConfig,
			rounding,
			extraShortcuts,
			textEditable,
			textKey,
		},
		{ handleTextClick, handleImageClick, handleTextChange, handleClick },
	] = useContent(props)

	return (
		<Grid className={cx(classes.root)} container justifyContent="center" onClick={handleClick}>
			<CommonContent
				mobileAlignment={mobileAlignment}
				image={image}
				text={text}
				textConfig={textConfig}
				classes={contentClasses}
				rounding={rounding}
				onImageClick={handleImageClick}
				onTextClick={handleTextClick}
				extraShortcuts={extraShortcuts}
				textEditable={textEditable}
				onTextChange={handleTextChange}
				textKey={textKey}
			/>
		</Grid>
	)
}

Content.propTypes = {
	buttonLink: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		content: PropTypes.string,
		image: PropTypes.string,
	}),
	image: PropTypes.instanceOf(PageMetaData),
	onImageClick: PropTypes.func,
	onTextClick: PropTypes.func,
	text: PropTypes.string,
	textConfig: PropTypes.object,
	rounding: PropTypes.number,
	extraShortcuts: PropTypes.objectOf(PropTypes.string),
	textEditable: PropTypes.bool,
	onTextChange: PropTypes.func,
	textKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mobileAlignment: PropTypes.instanceOf(PageMetaData),
	onClick: PropTypes.func,
}

export default memo(Content)
